import cn from 'classnames';
import React, { FC } from 'react';

import styles from './Content.module.scss';

type ContentProps = {
  className?: string;
  testID?: string;
  children: React.ReactNode;
} & React.ComponentProps<'div'>;

export const Content: FC<ContentProps> = (props) => {
  const { className, testID, children, ...rest } = props;

  return (
    <div
      className={cn(styles.container, className)}
      data-testid={testID}
      {...rest}
    >
      {children}
    </div>
  );
};
